import { Types } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '.././../asyncStatReducer'
import { DwellTimeline } from '../../types'

/**
 * WFH Dwell timeline reducer
 */
const wfhDwellTimeline = buildAsyncStatReducer({
    key: Metrics.WFH_DWELLTIMELINE,
    types: {
        request: Types.DASHBOARD_WFH_DWELLTIMELINE.request,
        success: Types.DASHBOARD_WFH_DWELLTIMELINE.success,
        failure: Types.DASHBOARD_WFH_DWELLTIMELINE.failure,
    },
    transform: (state, { payload = {} }): DwellTimeline => {
        const keys: string[] = Object.keys(payload)
        return keys.reduce((carry: DwellTimeline, date: string): DwellTimeline => {
            return [
                ...carry,
                {
                    moment: date as string,
                    time: payload[date] as number,
                },
            ] as DwellTimeline
        }, [] as DwellTimeline)
    },
})

export default wfhDwellTimeline
